const FileUploadProgressBar = ({ fileProgress }) => {
  return (
    <>
      <div className="m-1 w-full text-center">
        <p>جاري رفع الملف</p>
      </div>
      <div
        className="rounded-lg h-1.5 bg-primary text-white w-full"
        style={{ width: `${fileProgress}%` }}
      >
        {fileProgress}%
      </div>
    </>
  );
};

export default FileUploadProgressBar;
